<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-form
      ref="form"
      v-model="valid"
      @submit.prevent="update"
    >
      <v-card-text class="pb-0">
        <v-card-title>
          <v-icon
            size="26"
            class="text--primary me-3"
          >
            {{ icons.mdiShieldLock }}
          </v-icon>
          <span>Segurança</span>
        </v-card-title>

        <v-row class="mt-3">
          <v-col
            cols="12"
            sm="8"
            md="6"
          >
            <v-text-field
              v-model="accountDataLocale.email"
              label="E-mail"
              dense
              outlined
              :rules="[validators.required, validators.emailValidator]"
            ></v-text-field>

            <!-- new password -->
            <v-text-field
              v-model="senha1"
              :type="isNewPasswordVisible ? 'text' : 'password'"
              :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
              label="Nova senha"
              :rules="[validators.passwordValidator]"
              outlined
              dense
              hint="Mínimo 8 caracteres e máximo 40."
              persistent-hint
              @click:append="isNewPasswordVisible = !isNewPasswordVisible"
            ></v-text-field>

            <!-- confirm password -->
            <v-text-field
              v-model="accountDataLocale.senha"
              :type="isCPasswordVisible ? 'text' : 'password'"
              :append-icon="isCPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
              label="Confirme a nova senha"
              :rules="[validators.required, validators.passwordValidator, validators.confirmedValidator(senha1, accountDataLocale.senha)]"
              outlined
              dense
              class="mt-3"
              @click:append="isCPasswordVisible = !isCPasswordVisible"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-col cols="12">
        <v-btn
          v-if="acessoPut"
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          type="submit"
        >
          <v-progress-circular
            v-if="loading"
            class="mx-6"
            indeterminate
            color="secundary"
          ></v-progress-circular>
          <span v-else>Salvar alterações</span>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          disabled
          type="submit"
        >
          Salvar alterações
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          class="mb-2 mt-4"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { alphaValidator, confirmedValidator, emailValidator, passwordValidator, required } from '@core/utils/validation'
import {
  mdiShieldLock, mdiEyeOffOutline, mdiEyeOutline, mdiKeyOutline, mdiLockOpenOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    securityData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      senha1: '',
    }
  },
  setup(props) {
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.securityData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.securityData))
    }
    const form = ref(null)
    const isCurrentPasswordVisible = ref(false)
    const isNewPasswordVisible = ref(false)
    const isCPasswordVisible = ref(false)
    const valid = ref(false)
    const loading = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const update = () => {
      loading.value = !loading.value
      if (valid.value) {
        ColaboradorService
          .update(accountDataLocale.value)
          .finally(() => {
            loading.value = !loading.value
          })
      } else {
        loading.value = !loading.value
        validate()
      }
    }

    return {
      accountDataLocale,
      resetForm,
      form,
      validate,
      valid,
      isCurrentPasswordVisible,
      isNewPasswordVisible,
      isCPasswordVisible,
      loading,
      update,
      icons: {
        mdiShieldLock,
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
      validators: {
        confirmedValidator,
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
      },
    }
  },
  methods: {
    // update() {
    //   const isFormValid = this.registerForm.value.validate()
    //    if (!this.isFormValid) return

    //   this.accountDataLocale.senha = this.senha2
    //   this.accountDataLocale.id = null

    //   console.log(this.accountDataLocale)

    //   axiosWay
    //     .put('user/AtualizacaoPropria', this.accountDataLocale)
    // },
  },
}
</script>

<style lang="scss" scoped>
.two-factor-auth {
  max-width: 25rem;
}

.btns {
  position: relative;
  bottom: -20px;
}

.security-character {
  position: absolute;
  bottom: -0.5rem;
}

.border-green {
  border: 1px solid green;
}
</style>
